import { CUSTOMIZATION_TAGS } from '~/lib/constants'
import { collectionMetafields } from '~/lib/shopify/constants/metafields'
import { getProductFromShopify } from '~/lib/shopify/products'
import { metafieldsToObject } from '~/lib/shopify/utils/metafield-to-object'

import { serializeShopifyStorefrontData } from '~/data/product-card-data'

export async function serializeLabelCustomizationProducts(mainProduct, locale) {
  const collections = mainProduct?.collections
  const customizationProducts = collections
    ?.filter(Boolean)
    ?.map((collection) => {
      const metafields = metafieldsToObject(
        collection?.metafields,
        collectionMetafields,
      )
      return metafields.labelCustomizations
    })
    .filter(Boolean)
  let productsIds
  if (customizationProducts?.[0]) {
    productsIds = JSON.parse(customizationProducts?.[0])
  }

  const items =
    (await Promise.all(
      productsIds?.map(async (item) => {
        const product = await getProductFromShopify({
          locale,
          id: item,
        })

        const serializedStorefrontData = await serializeShopifyStorefrontData(
          product,
          locale,
          true,
        )

        /* It's checking if the product has a tag that matches one of the tags in the
          CUSTOMIZATION_TAGS object. */
        const type =
          Object.values(CUSTOMIZATION_TAGS).find(
            (item) => product?.tags?.indexOf(item) > -1,
          ) ?? null

        return {
          ...product,
          ...serializedStorefrontData,
          customizationType: type,
        }
      }) ?? [],
    )) ?? null

  return items
}
